<template>
  <a class="dropdown-item" @click.prevent="logout()" href="#">
    <icon-logout></icon-logout>
    {{ $t('header.a.logout') }}</a
  >
</template>

<script>
import IconLogout from '@/components/icons/logout'

export default {
  components: {
    'icon-logout': IconLogout,
  },
  methods: {
    logout() {
      this.$store.dispatch('user/logout')
    },
  },
}
</script>

<style></style>
